import { LocalDate } from '@js-joda/core';

import { Translate } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../translations';
import { InvoiceCreateFormController } from '../form/InvoiceCreateForm.types';
import { InvoicePaymentMethod } from '../../types';

import { ContinueWithoutReceiptModalConfirmButton } from './ContinueWithoutReceiptModalConfirmButton';
import { PrintReceiptAndCreateInvoiceModalConfirmButton } from './PrintReceiptAndCreateInvoiceModalConfirmButton';

type WithReceiptModalProps = Pick<InvoiceCreateFormController, 'handleSubmit'> & {
   readonly onClose: VoidFunction;
   readonly onSuccess: VoidFunction;
   readonly paymentMethod: InvoicePaymentMethod;
   readonly visitDate: LocalDate;
   readonly visitSettlementId: number;
};

export const WithReceiptModal = (props: WithReceiptModalProps): JSX.Element => {
   const { onClose, onSuccess, handleSubmit, paymentMethod, visitDate, visitSettlementId } = props;

   return (
      <Modal
         testId={'invoiceCreateWithReceiptModal'}
         title={invoiceCreateModalTranslationKeys.withReceipt.title}
         width={ModalWidth.NORMAL}
      >
         <Translate>{invoiceCreateModalTranslationKeys.withReceipt.subtitle}</Translate>
         <ContinueWithoutReceiptModalConfirmButton
            onSuccess={onSuccess}
            handleSubmit={handleSubmit}
            paymentMethod={paymentMethod}
            visitDate={visitDate}
            visitSettlementId={visitSettlementId}
         />
         <PrintReceiptAndCreateInvoiceModalConfirmButton
            onSuccess={onSuccess}
            handleSubmit={handleSubmit}
            paymentMethod={paymentMethod}
            visitDate={visitDate}
            visitSettlementId={visitSettlementId}
         />
         <ModalCancelButton onClick={onClose} />
         <ModalCloseButton onClick={onClose} />
      </Modal>
   );
};
